import React, { useState } from "react";
import axios from "axios";
import { baseUrl_SPB } from "../../BaseUrl";
import { useAuth } from "../../AuthProvider";

export default function BasiqConnectScreen() {
  const [loading, setLoading] = useState(false);
  const [connectUrl, setConnectUrl] = useState("");
  const authContext = useAuth();
  const handleConnect = async () => {
    try {
      setLoading(true);
       const  headers= {
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + authContext.token
  }
      // 1. Call your backend (NOT Basiq directly)
      const res = await axios.post(
        `${baseUrl_SPB}/api/v1/basiq/connect`,{}, {headers}
      );

      // 2. Backend returns Basiq consent URL
      const url = res.data;

      setConnectUrl(url);

      // 3. Redirect user to Basiq consent flow
      window.location.href = url;

    } catch (err) {
      console.error("Failed to connect bank:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Connect Bank (Basiq)</h2>
        {authContext.additionalUserInfo.phone && 
      <button onClick={handleConnect} disabled={loading}>
        {loading ? "Connecting..." : "Connect Bank Account"}
      </button>}
    </div>
  );
}